module.exports = __webpack_public_path__ + "static/media/icnBtnConfirmarDatos.357cfe9d.svg";